import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// TODO: Replace with your actual Firebase web app configuration
// You can find this in Firebase Console > Project Settings > General > Your apps > Web app
const firebaseConfig = {
  apiKey: "AIzaSyBXobdhrj8FZ4gpxirM2ZkEo3wkmkYI4SE",
  authDomain: "selamcentral-8406c.firebaseapp.com",
  projectId: "selamcentral-8406c",
  storageBucket: "selamcentral-8406c.appspot.com",
  messagingSenderId: "671422387762",
  appId: "1:671422387762:web:bc13c82f0f9c4a1231ce2b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;

